// src/components/SeasonSelector.js
import React from "react";
import { useSeason } from "../context/SeasonContext";

/**
 * Renders a season pill selector + historical-data banner.
 * Hidden when there is only one season available.
 */
export default function SeasonSelector() {
  const { availableSeasons, selectedSeasonID, setSelectedSeasonID } = useSeason();

  if (!availableSeasons || availableSeasons.length <= 1) return null;

  return (
    <div style={{ marginBottom: "0.75rem" }}>
      {/* Season pills */}
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "0.4rem" }}>
        {availableSeasons.map((s) => {
          const active = s === selectedSeasonID;
          return (
            <button
              key={s}
              onClick={() => setSelectedSeasonID(s)}
              style={{
                background: active ? "#50B4C8" : "#f4f7f8",
                color: active ? "#fff" : "#222",
                border: "1px solid #e5e7eb",
                borderRadius: "999px",
                padding: "0.3rem 0.85rem",
                fontSize: "0.82rem",
                fontWeight: "600",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              {s}
            </button>
          );
        })}
      </div>
    </div>
  );
}
